<mat-form-field style="margin-right: 10px;">
  <input matInput [(ngModel)]="currentDate" [matDatepicker]="picker" placeholder="{{holderText}}">
  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
